/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CopyDocumentResponseData,
  CopyDocumentResponseDataFromJSON,
  CopyDocumentResponseDataFromJSONTyped,
  CopyDocumentResponseDataToJSON
} from './CopyDocumentResponseData'

/**
 *
 * @export
 * @interface CreateDocumentPublishResponse
 */
export interface CreateDocumentPublishResponse {
  /**
   *
   * @type {number}
   * @memberof CreateDocumentPublishResponse
   */
  status?: number
  /**
   *
   * @type {CopyDocumentResponseData}
   * @memberof CreateDocumentPublishResponse
   */
  data?: CopyDocumentResponseData
}

export function CreateDocumentPublishResponseFromJSON(json: any): CreateDocumentPublishResponse {
  return CreateDocumentPublishResponseFromJSONTyped(json, false)
}

export function CreateDocumentPublishResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateDocumentPublishResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CopyDocumentResponseDataFromJSON(json['data'])
  }
}

export function CreateDocumentPublishResponseToJSON(value?: CreateDocumentPublishResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CopyDocumentResponseDataToJSON(value.data)
  }
}
